import { enqueueSnackbar } from 'notistack';
import { ReactElement } from 'react';
import { notificationContent } from '@/src/components/UIKit/Notification/Notification';

export enum NotificationStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum NotificationPlacement {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type NotificationBase = {
  text: {
    title: string,
    body?: string | ReactElement,
  },
  status: NotificationStatus,
  duration?: number, // time in seconds
  placement?: NotificationPlacement,
};

export const notify = ({
  text, duration, placement = NotificationPlacement.TOP, status,
}: NotificationBase) => {
  enqueueSnackbar(
    text.title,
    {
      variant: status,
      anchorOrigin: {
        vertical: placement,
        horizontal: 'right',
      },
      autoHideDuration: duration && duration * 1000,
      content: key => notificationContent({
        id: key, title: text.title, body: text.body, variant: status,
      }),
    },
  );
};
